import axios from "axios";
const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

let isInvalidAccessLogoutInProgress = false;

export const invalidAccessLogout = async (options = {}) => {
  // Skip logout on vendor portal—it uses a separate auth flow and should not trigger app logout
  if (typeof window !== 'undefined' && String(window.location.pathname || '').includes('/vendor-portal/')) {
    return;
  }
  if (isInvalidAccessLogoutInProgress) return;
  isInvalidAccessLogoutInProgress = true;

  const { skipLogoutApi = false } = options;
  const refreshToken = sessionStorage.getItem("refreshToken");

  try {
    if (!skipLogoutApi && refreshToken) {
      await axios.post(`${REACT_APP_BACKEND_ROUTE_URL}logout/`, {
        refresh_token: refreshToken,
      });
    }
  } catch (error) {
    console.error("Error while logging out:", error);
  } finally {
    sessionStorage.clear();
    window.dispatchEvent(new Event("app:logout"));
    window.location.href = "/login"; // using window.location as it's not a React component
  }
};
